


		function snow_pc(){
		/*
          var sliderlayer=document.getElementById("sliderlayer");
          if(typeof(sliderlayer)!="undefined"&&sliderlayer!=null){       
		         var sf1_slideshow = new Snowflakes({
		          color: "#ffffff",
		          count: 30,
		          minOpacity: 1,
		          maxOpacity: 1,
		          container:document.getElementById("sliderlayer"),
		          minSize:5,
		          maxSize:30,
		          height:450
		        });   

        }
           
		*/
      /*
     
          var footer=document.getElementById("footercenter");
          if(typeof(footer)!="undefined"&&footer!=null){
		         var sf1_footer_top = new Snowflakes({
		          color: "#ffffff",
		          count: 30,
		          minOpacity: 1,
		          maxOpacity: 1,
		          container:document.getElementById("footercenter"),
		          minSize:5,
		          maxSize:30,
                   height:100
		        });      
        }
          */
          

         var sf1_footer_center = new Snowflakes({
          color: "#fff",
          count: 10,
          minOpacity: 1,
          maxOpacity: 1,
          minSize:10,
          maxSize:20
        }); 
        
         
          
      }


		function snow_mobile(){
          
          var sf1_footer_center = new Snowflakes({
          color: "#ffde6b",
          count: 8,
          minOpacity: 1,
          maxOpacity: 1,
          minSize:5,
          maxSize:20
        });          
          
          
        } 


		

		if(document.body.clientWidth>800)
		snow_pc();
	    else snow_mobile();
  	
        /*
         var sf1_footer_center = new Snowflakes({
          color: "#ffffff",
          count: 30,
          minOpacity: 1,
          maxOpacity: 1,
          minSize:5,
          maxSize:30
        }); 
        */


/*
function  judge_page(){
	var img=document.getElementById(img_bottom_snow);
	var footertop=document.getElementById("footertop");
	if(typeof(footertop)!="undefined")
		img.src="https://cdn.shopify.com/s/files/1/1978/9859/files/bottom.png?v=1575453442";
	else img.src="https://cdn.shopify.com/s/files/1/1978/9859/files/bottom_02.png?v=1575537727"
}
*/
